import {
    IconButton,
    styled,
} from "@l2r-front/l2r-ui"

export const Header = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(5),
}))

export const BackButton = styled(IconButton)(() => ({
    padding: 0,
}))
